import React from 'react';
import { Star } from 'lucide-react';

const MentorBadge = React.forwardRef(({ show, withLabel = true, size = 12, className = '', ...rest }, ref) => {
  if (!show) return null;
  return (
    <span
      ref={ref}
      aria-label="Sirati Mentor"
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${className}`}
      style={{ background: 'rgba(234,179,8,0.15)', color: '#92680a' }}
      data-testid="mentor-badge"
      {...rest}
    >
      <Star aria-hidden="true" style={{ width: size, height: size }} />
      {withLabel && <span>Mentor</span>}
    </span>
  );
});
MentorBadge.displayName = 'MentorBadge';

export default MentorBadge;
